import {getAuthMsg}  from 'http/api/guildUserAndSetting'
import store from '@/store/index'

// 判断参数是否有值
export const isEmpty = (val) => {
  if (val === null || val === undefined || val === "") {
    return true;
  }
  return false;
}


export const getAuthForm = function() {
  console.log('store.state.auth',store.state.auth);
  const userInfo = store.state.auth.authInfo
  if(userInfo.userOrgType!==null&&userInfo.userOrgType!==undefined){
    return userInfo
  }
  return new Promise((resolve, reject) => {
     getAuthMsg().then(res => {
      const data = res.data||{}
       store.dispatch('seAuthInfo', data)
      resolve(data)
       
    }).catch((err)=>{
      reject(err)

    })
  })
   
     
  }